import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import logo from "../logo.png"

const Login = () => {
  const { t } = useTranslation();

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().email('Invalid email address').required('Required'),
      password: Yup.string().required('Required'),
    }),
    onSubmit: async (values) => {
      try {
        const response = await fetch('https://test.creative-its.com/back/api/admin/login', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(values),
        });

        if (response.ok) {
          const data = await response.json();
          const token = data.token;
          localStorage.setItem('token', token);
          window.location.href = '/dashboard';
        } else {
          console.error('Login failed');
        }
      } catch (error) {
        console.error('Error during login:', error);
      }
    },
  });

  return (
    <div className="min-h-screen bg-black flex flex-col items-center justify-center">
      {/* Background Video */}
      <video
        className="absolute top-0 left-0 z-0 w-full h-full object-cover"
        autoPlay
        loop
        muted
      >
        <source src="loginBackground.mp4" type="video/mp4" />
        {/* Add more source elements for different video formats if needed */}
        Your browser does not support the video tag.
      </video>

      {/* Login Form */}
      <div className="relative z-10 p-8 pt-6 rounded shadow-md max-w-md w-full flex flex-col items-center" style={{ background: 'linear-gradient(to bottom, rgba(177, 177, 177, 0.5) 40%, rgba(255, 255, 255, 0.5) 20%, rgba(177, 177, 177, 0.5) 40%)' }}>
        <img src={logo} alt="Logo" className='mb-2 w-[70px]' />
        <form className="flex flex-col items-center w-[80%]" onSubmit={formik.handleSubmit}>
          <div className="w-full mb-4">
            <input
              type="text"
              id="email"
              name="email"
              placeholder={t('login.email')}
              className="mt-1 p-2 w-full border rounded-md border-white text-black" // Change text color to black
              {...formik.getFieldProps('email')}
            />
            {formik.touched.email && formik.errors.email ? (
              <div className="text-red-500">{formik.errors.email}</div>
            ) : null}
          </div>
          <div className="w-full mb-4">
            <input
              type="password"
              id="password"
              name="password"
              placeholder={t('login.password')}
              className="mt-1 p-2 w-full border rounded-md border-white text-black" // Change text color to black
              {...formik.getFieldProps('password')}
            />
            {formik.touched.password && formik.errors.password ? (
              <div className="text-red-500">{formik.errors.password}</div>
            ) : null}
          </div>
          <button type="submit" className="text-black px-4 py-2 rounded-md w-full bg-white">Login</button>
        </form>
      </div>
    </div>
  );
};

export default Login;
